export const classNameParserCore = (...args) => {
    const appendArray = (arr) => arr.filter(Boolean).join(" ");
    const appendObject = (obj) => Object.keys(obj)
        .filter((key) => obj[key])
        .join(" ");
    const processInput = (input) => {
        if (Array.isArray(input)) {
            return appendArray(input);
        }
        else if (typeof input === "object" && input !== null) {
            return appendObject(input);
        }
        else if (typeof input === "string") {
            return input.trim();
        }
        return ""; // For undefined, null, or other falsy values
    };
    return args
        .map(processInput)
        .filter(Boolean) // Remove falsy or empty values
        .join(" ");
};
